/**
 * Small, dependency-free helpers for sticky ATC and size clarity.
 * No third-party libraries.
 */
(function () {
  const sticky = document.querySelector('[data-pawreve-sticky-atc]');
  const stickyButton = document.querySelector('[data-pawreve-sticky-atc-button]');
  const productForm = document.querySelector('form[action*="/cart/add"]');
  const nativeSubmit = productForm
    ? productForm.querySelector('[type="submit"], .product-form__submit')
    : null;

  if (sticky && nativeSubmit) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            sticky.classList.remove('is-visible');
          } else {
            sticky.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.2 }
    );
    observer.observe(nativeSubmit);

    if (stickyButton) {
      stickyButton.addEventListener('click', () => {
        if (typeof nativeSubmit.click === 'function') {
          nativeSubmit.click();
        }
        nativeSubmit.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  const variantFieldset = document.querySelector('variant-selects, variant-radios, .product-form__input');
  if (variantFieldset) {
    variantFieldset.setAttribute('data-pawreve-variant-group', 'true');
  }
})();
